export enum BillingTypes {
  ENERGY = 'energy',
  WATER = 'water',
  DANFE = 'danfe',
}
